import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const KEY = "rentos_cookie_consent";

export function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  if (!show) return null;

  const accept = () => { localStorage.setItem(KEY, "yes"); setShow(false); };
  const reject = () => { localStorage.setItem(KEY, "no"); setShow(false); };

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[950] sm:left-auto sm:right-6 sm:max-w-sm" role="dialog" aria-label="Cookie consent">
      <div className="glass rounded-2xl border border-border p-4 shadow-elegant">
        <p className="text-sm leading-relaxed text-muted-foreground">
          We use cookies for analytics.{" "}
          <Link to="/legal?tab=cookie-policy" className="text-primary underline">Learn more</Link>.
        </p>
        <div className="mt-3 flex gap-2">
          <button
            type="button"
            onClick={accept}
            className="rounded-lg bg-gradient-primary px-3.5 py-1.5 text-xs font-semibold text-primary-foreground shadow-glow"
          >
            Accept
          </button>
          <button
            type="button"
            onClick={reject}
            className="rounded-lg border border-border px-3.5 py-1.5 text-xs font-semibold text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}
